import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Assessment from "../pages/assessment/page";
import LeadCapture from "../pages/lead-capture/page";
import Processing from "../pages/processing/page";
import Report from "../pages/report/page";
import AccountPage from "../pages/account/page";
import ResetPasswordPage from "../pages/reset-password/page";
import AdminLayout from "../pages/admin/components/AdminLayout";
import AdminLogin from "../pages/admin/login/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import AdminAgeGroups from "../pages/admin/age-groups/page";
import AdminCategories from "../pages/admin/categories/page";
import AdminSkills from "../pages/admin/skills/page";
import AdminProducts from "../pages/admin/products/page";
import AdminOrders from "../pages/admin/orders/page";
import AdminMappings from "../pages/admin/mappings/page";
import AdminCrm from "../pages/admin/crm/page";
import AdminSettings from "../pages/admin/settings/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/assessment/:ageGroupId",
    element: <Assessment />,
  },
  {
    path: "/lead-capture",
    element: <LeadCapture />,
  },
  {
    path: "/processing",
    element: <Processing />,
  },
  {
    path: "/report/:reportId",
    element: <Report />,
  },
  {
    path: "/account",
    element: <AccountPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { path: "/admin", element: <AdminDashboard /> },
      { path: "/admin/age-groups", element: <AdminAgeGroups /> },
      { path: "/admin/categories", element: <AdminCategories /> },
      { path: "/admin/skills", element: <AdminSkills /> },
      { path: "/admin/settings", element: <AdminSettings /> },
      { path: "/admin/products", element: <AdminProducts /> },
      { path: "/admin/orders", element: <AdminOrders /> },
      { path: "/admin/mappings", element: <AdminMappings /> },
      { path: "/admin/crm", element: <AdminCrm /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
